import { render, staticRenderFns } from "./defaultExchange.vue?vue&type=template&id=e703cc0e&scoped=true&"
import script from "./defaultExchange.vue?vue&type=script&lang=js&"
export * from "./defaultExchange.vue?vue&type=script&lang=js&"
import style0 from "./defaultExchange.vue?vue&type=style&index=0&id=e703cc0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e703cc0e",
  null
  
)

export default component.exports